import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { LicenseInfo } from '@mui/x-license-pro';

import '@fontsource/roboto';

import DashboardPage from './pages/DashboardPage';
import LoginPage from './auth/LoginPage';
import JoinPage from './auth/JoinPage';
import LoginForgotPage from 'auth/LoginForgotPage';
import SlateEditor from 'pages/admin/cards/templates/SlateEditor';
import CardPage from './pages/CardPage';
import muiTheme from 'theme/MuiTheme';
import { ThemeProvider } from '@mui/material/styles';
import globalStyles from 'theme/GlobalStyle';
import { GlobalStyles } from '@mui/material';


LicenseInfo.setLicenseKey('2a9b3a33af8f63cb4dbe615f3091518aTz01Nzk4NixFPTE3MDU2Njc0MDQ2NzIsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');


const inputGlobalStyles = <GlobalStyles styles={globalStyles} />;

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
    <ThemeProvider theme={muiTheme}>
        {inputGlobalStyles}

        <BrowserRouter>
            <Routes>
                <Route path='/' element={<DashboardPage />} />
                <Route path='/login' element={<LoginPage />} />
                <Route path='/join' element={<JoinPage />} />
                <Route path='/forgot' element={<LoginForgotPage />} />

                <Route path='/cards' element={<DashboardPage tab='cards' />} />
                <Route path='/card/:cardId' element={<CardPage />} />

                <Route path='/admin' element={<DashboardPage />} />

                <Route path='/create_template' element={<SlateEditor />} />
            </Routes>
        </BrowserRouter>
    </ThemeProvider>

);
